// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1e9a2e8b","212":"1522aff3","249":"c2c4cf4d","259":"46543e73","376":"24001b9b","525":"18c5d463","594":"c81e2316","611":"3098dbad","641":"517ba91f","678":"eba545d8","831":"09c1ae03","858":"7ec54eb2","963":"ff0a37e5"}[chunkId] + ".chunk.js";
};